import ErrorScreen from './ErrorScreen';

const Unauthorized = () => <ErrorScreen defaultMessage='Unauthorized' />;

export default Unauthorized;
